import {
  Component,
  OnInit,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
  AfterViewInit,
  DoCheck,
} from "@angular/core";
import * as XLSX from "xlsx";
import { DomSanitizer } from "@angular/platform-browser";
import * as FileSaver from "file-saver";
import _ from "underscore";
import { ActivatedRoute } from "@angular/router";
import { ToastrService } from "ngx-toastr";
import { DataDirectoryService } from "../data-directory/data-directory.service";
import { environment } from "src/environments/environment.prod";
import { ScrapingupdateService } from "../scrapingupdate/scrapingupdate.service";

@Component({
  selector: "app-scrapingupdate",
  templateUrl: "./scrapingupdate.component.html",
  styleUrls: ["./scrapingupdate.component.scss"],
})
export class ScrapingupdateComponent implements OnInit {
  DragData: any = {};
  submolecules: any[];
  ndamolecules: any[];
  fieldmolecules: any[];
  subMolecule = false;
  selectedSubMolecule: any;
  selectedNDAMolecule: any;
  selectedFieldMolecule: any;
  Moleculedata: any;
  specifiecdata: any;
  page_access = { total_count: "undefined" };
  total_count = "undefined";
  refEditData = {};
  Molecule = false;
  searchValue = "";
  noData = false;
  tempData: any = {};
  fieldname: any;
  tableheader: any;
  id: any;
  nda_number: any;
  brand_name: any;
  roa: any;
  dosage_form: any;
  natural_dosage_form: any;
  newdata: any;
  olddata: any;
  editeddata: any;
  newexeclusivetycode: any;
  oldexeclusivetycode: any;
  editedexeclusivetycode: any;
  newexclusivityexpiration: any;
  oldexclusivityexpiration: any;
  editedexclusivityexpiration: any;
  newstregth: any;
  newprice: any;
  newRoa: any;
  editedstregth: any;
  approvestatus: boolean = false;
  rejectstatus: boolean = false;
  pendingstatus: boolean = false;
  button: boolean = false;
  extractedValue: any;
  newexeclusivetyarray;
  oldexeclusivetyarray;
  editedexeclusivetyarray;
  showedit = false;
  sliceEnd = 5;
  oldbutton;
  commandata;
  approveddata: any;
  counter = 0;
  editedkey: any;
  volumeheader: string[] = [];
  isValueChanged: boolean = false;
  ndaNumberPresent: boolean = false;
  editedData: any[] = [];
  selectedMolecule: any;
  rowData: any[] = [];
  deletedRowValue: any = [];
  deletedRowNewValue: any = [];
  newandadrugs: any;
  newandaactive: any;
  newmarketstatus: any;
  newapproval: any;
  newapplicantholder: any;
  newDmfHolder: any;
  newDmfSubject: any;
  newDmfSubmitDate: any;
  iprNumber: any;
  iprResNumber: any;
  iprPartyName: any;
  iprStatusCat: any;
  iprCounselName: any;
  newMarketingStatus: any;
  valindex: any;
  row: any;
  indicativeSpecificOldData: any;
  indicativeSpecificNewData: any;
  exclusivityFields: any;
  deletedIndexes: any;
  removedElements: any = {};
  UserIp: any;
  email: any;
  newPdeProduct: any;
  newPdeExpiration: any;
  newPdeExtension: any;

  constructor(
    private ref: ChangeDetectorRef,
    public toastr: ToastrService,
    private route: ActivatedRoute,
    private scrapingupdateservice: ScrapingupdateService
  ) { }
  ngOnInit(): void {
    this.UserIp = localStorage.getItem("ipaddress");
    this.email = localStorage.getItem("email");
    // console.log("UserIp", this.UserIp, this.email);
    this.page_access = JSON.parse(localStorage.getItem("page_access")) || {
      total_count: "undefined",
    };
    this.total_count = this.page_access.total_count || "undefined";
  }
  clearFilter() {
    this.submolecules = [];
    this.selectedSubMolecule = {};
    this.ndamolecules = [];
    this.selectedNDAMolecule = {};
    this.fieldmolecules = [];
    this.selectedFieldMolecule = {};
    this.Molecule = false;
    this.searchValue = "";
    this.subMolecule = false;
    this.noData = false;
    location.reload();
  }

  arrayToDropdown(InputArray) {
    let DropDownArray = [];
    InputArray.forEach((DropdownValues) => {
      let dropDownObj = {};
      dropDownObj["name"] = DropdownValues;
      dropDownObj["code"] = DropdownValues;
      DropDownArray.push(dropDownObj);
    });
    return DropDownArray;
  }
  searchMolecule() {
    if (this.counter > 0) {
      location.reload();
    }
    // this.submolecules = [];
    let value = "Approved";
    let dropdownvalues = this.arrayToDropdown([
      "APPROVED",
      "REJECTED",
      "PENDING",
    ]);
    if (this.selectedSubMolecule !== undefined) {
      console.log("123", this.selectedSubMolecule);
    }
    this.submolecules = dropdownvalues;
    this.subMolecule = true;
    this.Molecule = false;
    this.DragData = {};
    this.refEditData = {};
    if (this.selectedSubMolecule !== undefined) {
      // location.reload();
      this.getData();
    }
  }
  getData() {
    if (this.selectedSubMolecule !== undefined) {
      if (this.selectedSubMolecule == "REJECTED") {
        this.approvestatus = true;
      } else if (this.selectedSubMolecule == "APPROVED") {
        this.rejectstatus = true;
      } else {
        this.pendingstatus = true;
      }
      let ndaValue: any = { status: this.selectedSubMolecule["code"], user_email: this.email };
      this.scrapingupdateservice
        .getScrapingFieldData(ndaValue)
        .subscribe((MoleculeData: any) => {
          if (MoleculeData != null) {
            this.fieldname = MoleculeData["data"];
          }
        });
    }
  }
  searchMolecule1() {
    this.ndamolecules = [];
    // for (let i = 0; i < this.Moleculedata.length; i++) {
    //   let nda_number = this.Moleculedata[i]["NDA number"];
    //   let brand_name = this.Moleculedata[i]["Brand Name"];
    //   let combine_data = this.Moleculedata[i]["combine_data"];
    //   arr.push(combine_data);
    // }
    if (this.fieldname.length > 0) {
      let ndaMoleculeData = this.arrayToDropdown(
        this.fieldname.map((item) => item)
      );
      this.ndamolecules = ndaMoleculeData;
      this.subMolecule = true;
      this.Molecule = false;
      this.DragData = {};
      this.refEditData = {};
    }
    if (this.selectedNDAMolecule !== undefined) {
      this.selectedMolecule = this.selectedNDAMolecule.name;
      this.getAllScrapingFieldList();
    }
  }
  getAllScrapingFieldList() {
    if (this.selectedNDAMolecule !== undefined) {
      let ndaValue: any = {
        status: this.selectedSubMolecule["code"].trim(),
        field_name: this.selectedNDAMolecule["code"],
      };
      this.scrapingupdateservice
        .getMoleculeData(ndaValue)
        .subscribe((MoleculeData: any) => {
          this.Moleculedata = MoleculeData["data"];
        });
    }
  }
  searchMolecule2() {
    let arr = [];
    this.fieldmolecules = [];
    for (let i = 0; i < this.Moleculedata.length; i++) {
      let nda_number = this.Moleculedata[i]["NDA number"];
      let brand_name = this.Moleculedata[i]["Brand Name"];
      let combine_data = this.Moleculedata[i]["combine_data"];
      arr.push(combine_data);
    }
    if (arr.length > 0) {
      let dropdownvalues = this.arrayToDropdown(arr);
      this.fieldmolecules = dropdownvalues;
      this.subMolecule = true;
      this.Molecule = false;
      this.DragData = {};
      this.refEditData = {};
    }
    if (this.selectedSubMolecule !== undefined) {
      this.getSpecifieconefieldData();
    }
  }

  getSpecifieconefieldData() {
    if (this.selectedFieldMolecule !== undefined) {
      if (Array.isArray(this.fieldname) && this.fieldname.length > 0) {
        this.extractedValue = this.selectedNDAMolecule["code"];
        let ndaValue: any = {
          status: this.selectedSubMolecule["code"].trim(),
          nda_number: this.selectedFieldMolecule["code"].split(",")[1].trim(),
          brand_name: this.selectedFieldMolecule["code"].split(",")[0].trim(),
          field_name: this.extractedValue,
        };
        this.scrapingupdateservice
          .getSpecifiecOneFieldData(ndaValue)
          .subscribe((MoleculeData: any) => {
            this.counter++;
            this.specifiecdata = MoleculeData["data"][0]["updated_fileds"];
            console.log("specific dataaaa", this.specifiecdata);
            let detail = this.selectedNDAMolecule["code"];
            if (
              this.selectedNDAMolecule["code"] == "Indicative API price ($/kg)"
            ) {
              this.tableheader = this.selectedNDAMolecule["code"];
              this.indicativeSpecificNewData =
                this.specifiecdata.new_data[
                  "Indicative API price ($/kg)"
                ].value;
              this.indicativeSpecificOldData =
                this.specifiecdata.old_data[
                  "Indicative API price ($/kg)"
                ].value;
              console.log("In", this.indicativeSpecificOldData);
            }
            else if (
              this.selectedNDAMolecule["code"] == "PDE applied 6 months*"
            ) {
              this.tableheader = this.selectedNDAMolecule["code"];
              this.indicativeSpecificNewData =
                this.specifiecdata.new_data[
                  "PDE applied 6 months*"
                ].value;
              this.indicativeSpecificOldData =
                this.specifiecdata.old_data[
                  "PDE applied 6 months*"
                ].value;
              console.log("In", this.indicativeSpecificOldData);
            }
            // Assuming this block is inside your component or service method
            if (this.selectedNDAMolecule["code"] == "Orphan Drug Exclusivity") {
              this.tableheader = this.selectedNDAMolecule["code"];

              // Handle new data array
              if (Array.isArray(this.specifiecdata.new_data["Orphan Drug Exclusivity"].value)) {
                this.indicativeSpecificNewData = this.specifiecdata.new_data["Orphan Drug Exclusivity"].value;
              } else {
                this.indicativeSpecificNewData = [this.specifiecdata.new_data["Orphan Drug Exclusivity"].value];
              }

              // Handle old data array
              if (Array.isArray(this.specifiecdata.old_data["Orphan Drug Exclusivity"].value)) {
                this.indicativeSpecificOldData = this.specifiecdata.old_data["Orphan Drug Exclusivity"].value;
              } else {
                this.indicativeSpecificOldData = [this.specifiecdata.old_data["Orphan Drug Exclusivity"].value];
              }
              console.log("In", this.indicativeSpecificOldData);
            } else if (this.selectedNDAMolecule["code"] == "Reference Listed Drug (RLD)") {
              this.tableheader = this.selectedNDAMolecule["code"];

              // Handle new data array
              if (Array.isArray(this.specifiecdata.new_data["Reference Listed Drug (RLD)"].value)) {
                this.indicativeSpecificNewData = this.specifiecdata.new_data["Reference Listed Drug (RLD)"].value;
              } else {
                this.indicativeSpecificNewData = [this.specifiecdata.new_data["Reference Listed Drug (RLD)"].value];
              }

              // Handle old data array
              if (Array.isArray(this.specifiecdata.old_data["Reference Listed Drug (RLD)"].value)) {
                this.indicativeSpecificOldData = this.specifiecdata.old_data["Reference Listed Drug (RLD)"].value;
              } else {
                this.indicativeSpecificOldData = [this.specifiecdata.old_data["Reference Listed Drug (RLD)"].value];
              }
              console.log("In", this.indicativeSpecificOldData);
            } else if (this.selectedNDAMolecule["code"] == "Reference Standard (RS)") {
              this.tableheader = this.selectedNDAMolecule["code"];

              // Handle new data array
              if (Array.isArray(this.specifiecdata.new_data["Reference Standard (RS)"].value)) {
                this.indicativeSpecificNewData = this.specifiecdata.new_data["Reference Standard (RS)"].value;
              } else {
                this.indicativeSpecificNewData = [this.specifiecdata.new_data["Reference Standard (RS)"].value];
              }

              // Handle old data array
              if (Array.isArray(this.specifiecdata.old_data["Reference Standard (RS)"].value)) {
                this.indicativeSpecificOldData = this.specifiecdata.old_data["Reference Standard (RS)"].value;
              } else {
                this.indicativeSpecificOldData = [this.specifiecdata.old_data["Reference Standard (RS)"].value];
              }
              console.log("In", this.indicativeSpecificOldData);
            }
            if (
              this.selectedSubMolecule.code !== "REJECTED" &&
              this.selectedSubMolecule.code !== "APPROVED"
            ) {
              this.button = true;
            }
            this.commandata = MoleculeData["product_data"][0];
            this.id = MoleculeData["data"][0]["_id"];
            if (this.selectedSubMolecule.code === "APPROVED") {
              for (let i = 0; i < MoleculeData["data"].length; i++) {
                if ("edited data" in MoleculeData["data"][i]) {
                  this.ndaNumberPresent = true;
                  this.editeddata =
                    MoleculeData["data"][0]["edited data"][detail]["value"][0];
                  let editedarray = [];
                  let editedexeclusivetyarray = [];
                  let newstregtharray = [];
                  if (this.editeddata.length > 0) {
                    for (let i = 0; i < this.editeddata.length; i++) {
                      this.editedexeclusivetycode =
                        this.editeddata[i]["Exclusivity Code"];
                      editedarray.push(this.editedexeclusivetycode);
                      this.editedexclusivityexpiration =
                        this.editeddata[i]["Exclusivity Expiration"];
                      editedarray.push(this.editedexeclusivetycode);
                      this.editedstregth =
                        this.editeddata[i]["Exclusivity Expiration"];
                      editedarray.push(this.editedexeclusivetycode);
                    }
                  }
                  let transformedArray: any = [];
                  if (
                    this.selectedNDAMolecule["code"] == "Exclusivity details"
                  ) {
                    this.tableheader = this.selectedNDAMolecule["code"];
                    this.volumeheader = [
                      "Exclusivity Code",
                      "Exclusivity Expiration",
                      "Strength",
                    ];
                    transformedArray = this.editeddata.map((item) => [
                      item["Exclusivity Code"],
                      item["Exclusivity Expiration"],
                      item["Strength"],
                    ]);
                  }
                  if (
                    this.selectedNDAMolecule["code"] ==
                    "Innovator / RLD Price ($/pack)"
                  ) {
                    this.tableheader = this.selectedNDAMolecule["code"];
                    this.volumeheader = [
                      "Quantity",
                      "Per Unit",
                      "Price",
                      "Strengths",
                      "Roa",
                    ];
                    transformedArray = this.editeddata.map((item) => [
                      item["Quantity"],
                      item["Per unit"],
                      item["Price"],
                      item["Strengths"],
                      item["Roa"],
                    ]);
                  }
                  if (
                    this.selectedNDAMolecule["code"] == "Existing DMF filers"
                  ) {
                    this.tableheader = this.selectedNDAMolecule["code"];
                    this.volumeheader = [
                      "DMF#",
                      "SUBMIT DATE",
                      "HOLDER",
                      "SUBJECT",
                    ];
                    transformedArray = this.editeddata.map((item) => [
                      item["DMF#"],
                      item["SUBMIT DATE"],
                      item["HOLDER"],
                      item["SUBJECT"]
                    ]);
                  }
                  if (
                    this.selectedNDAMolecule["code"] == "IPR details (if any)"
                  ) {
                    this.tableheader = this.selectedNDAMolecule["code"];
                    this.volumeheader = [
                      "proceedingFilingDate",
                      "proceedingNumber",
                      "respondentPatentNumber",
                      "petitionerPartyName",
                      "proceedingStatusCategory",
                      "petitionerCounselName",
                    ];
                    transformedArray = this.editeddata.map((item) => [
                      item["proceedingFilingDate"],
                      item["proceedingNumber"],
                      item["respondentPatentNumber"],
                      item["petitionerPartyName"],
                      item["proceedingStatusCategory"],
                      item["petitionerCounselName"]
                    ]);
                  }
                  if (
                    this.selectedNDAMolecule["code"] == "Marketing Status"
                  ) {
                    this.tableheader = this.selectedNDAMolecule["code"];
                    this.volumeheader = [
                      "Strength",
                      "Marketing Status",
                    ];
                    transformedArray = this.editeddata.map((item) => [
                      item["Strength"],
                      item["Marketing Status"],
                    ]);
                  }
                  if (
                    this.selectedNDAMolecule["code"] == "PTE applied (Max 5 years)"
                  ) {
                    this.tableheader = this.selectedNDAMolecule["code"];
                    this.volumeheader = [
                      "Patent No",
                      "Tradename of Product (generic name, if applicable)",
                      "Original Expiration Date*",
                      "Period of Extension Granted"
                    ];
                    transformedArray = this.editeddata.map((item) => [
                      item["Patent No"],
                      item["Tradename of Product (generic name, if applicable)"],
                      item["Original Expiration Date*"],
                      item["Period of Extension Granted"],
                    ]);
                  }
                  if (
                    this.selectedNDAMolecule["code"] == "Approved ANDA filers"
                  ) {
                    this.tableheader = this.selectedNDAMolecule["code"];
                    this.volumeheader = [
                      "ANDA No",
                      "Drug Name",
                      "Active Ingredients",
                      "Strength",
                      "Dosage Form/Route",
                      "Marketing Status",
                      "Approval Date",
                      "Applicant Holder",
                    ];
                    transformedArray = this.editeddata.map((item) => [
                      item["ANDA No"],
                      item["Drug Name"],
                      item["Active Ingredients"],
                      item["Strength"],
                      item["Dosage Form/Route"],
                      item["Marketing Status"],
                      item["Approval Date"],
                      item["Applicant Holder"],
                    ]);
                  }
                  this.editedexeclusivetyarray = transformedArray;
                  break; // Exit the loop once found
                }
              }
              this.editedkey = MoleculeData["data"][0]["edited data"];
            }
            if (
              this.selectedNDAMolecule["code"] == "Exclusivity details" ||
              this.selectedNDAMolecule["code"] ==
              "Innovator / RLD Price ($/pack)" ||
              this.selectedNDAMolecule["code"] == "Approved ANDA filers" ||
              this.selectedNDAMolecule["code"] == "Existing DMF filers" ||
              this.selectedNDAMolecule["code"] == "IPR details (if any)" ||
              this.selectedNDAMolecule["code"] == "Marketing Status" ||
              this.selectedNDAMolecule["code"] == "PTE applied (Max 5 years)"
            ) {
              this.tableheader = this.selectedNDAMolecule["code"];
              console.log("thisssstableee", this.tableheader)
              // this.volumeheader = Object.keys(this.specifiecdata.newdata);
              // console.log("volumeheadervolumeheader", this.volumeheader)
              if (this.selectedSubMolecule.code === "REJECTED") {
                this.newdata =
                  MoleculeData["data"][0]["rejected data"][detail]["value"];
              } else if (
                this.selectedSubMolecule.code === "APPROVED" &&
                this.newdata == undefined
              ) {
                this.newdata =
                  MoleculeData["data"][0]["updated_fileds"]["new_data"][detail][
                  "value"
                  ];
              } else if (this.selectedSubMolecule.code === "PENDING") {
                this.newdata =
                  MoleculeData["data"][0]["pending data"][detail]["value"];
              }
              console.log("newwwww dataaaa", this.newdata);
              let newexeclusivetyarray = [];
              if (
                this.newdata != undefined &&
                this.selectedNDAMolecule["code"] == "Exclusivity details"
              ) {
                if (this.newdata.length > 0) {
                  for (let i = 0; i < this.newdata.length; i++) {
                    this.newexeclusivetycode =
                      this.newdata[i]["Exclusivity Code"];
                    newexeclusivetyarray.push(this.newexeclusivetycode);
                    this.newexclusivityexpiration =
                      this.newdata[i]["Exclusivity Expiration"];
                    newexeclusivetyarray.push(this.newexeclusivetycode);
                    this.newstregth = this.newdata[i]["Exclusivity Expiration"];
                    newexeclusivetyarray.push(this.newexeclusivetycode);
                  }
                }
                const transformedArray = this.newdata.map((item) => [
                  item["Exclusivity Code"],
                  item["Exclusivity Expiration"],
                  item["Strength"],
                ]);
                this.olddata =
                  MoleculeData["data"][0]["updated_fileds"]["old_data"][detail][
                  "value"
                  ];
                if (typeof this.olddata !== "string") {
                  const oldtransformedArray = this.olddata.map((item) => [
                    item["Exclusivity Code"],
                    item["Exclusivity Expiration"],
                    item["Strength"],
                  ]);
                  this.oldexeclusivetyarray = oldtransformedArray;
                } else {
                  const oldtransformedArray = [["N/A", "N/A", "N/A"]];
                  this.oldexeclusivetyarray = oldtransformedArray;
                  this.oldbutton = false;
                }
                this.newexeclusivetyarray = transformedArray;
              }
              if (
                this.newdata != undefined &&
                this.selectedNDAMolecule["code"] ==
                "Innovator / RLD Price ($/pack)"
              ) {
                if (this.newdata.length > 0) {
                  for (let i = 0; i < this.newdata.length; i++) {
                    this.newexeclusivetycode = this.newdata[i]["Quantity"];
                    newexeclusivetyarray.push(this.newexeclusivetycode);
                    this.newexclusivityexpiration = this.newdata[i]["Per unit"];
                    newexeclusivetyarray.push(this.newexeclusivetycode);
                    this.newprice = this.newdata[i]["Price"];
                    newexeclusivetyarray.push(this.newexeclusivetycode);
                    this.newstregth = this.newdata[i]["Strengths"];
                    newexeclusivetyarray.push(this.newexeclusivetycode);
                    this.newRoa = this.newdata[i]["Roa"];
                    newexeclusivetyarray.push(this.newexeclusivetycode);
                  }
                }
                const transformedArray = this.newdata.map((item) => [
                  item["Quantity"],
                  item["Per unit"],
                  item["Price"],
                  item["Strengths"],
                  item["Roa"],
                ]);
                this.olddata =
                  MoleculeData["data"][0]["updated_fileds"]["old_data"][detail][
                  "value"
                  ];
                // this.olddata = [this.olddata];
                if (typeof this.olddata !== "string") {
                  const oldtransformedArray = this.olddata.map((item) => {
                    const quantity = item["Quantity"] ?? "";
                    const perUnit = item["Per unit"] ?? "";
                    const price = item["Price"] ?? "";
                    const strengths = item["Strengths"] ?? "";
                    const roa = item["Roa"] ?? "";
                    return [quantity, perUnit, price, strengths, roa];
                  });
                  console.log(oldtransformedArray);
                  this.oldexeclusivetyarray = oldtransformedArray;
                } else {
                  const oldtransformedArray = [["N/A", "N/A", "N/A"]];
                  this.oldexeclusivetyarray = oldtransformedArray;
                  this.oldbutton = false;
                }
                this.newexeclusivetyarray = transformedArray;
              }
              if (
                this.newdata != undefined &&
                this.selectedNDAMolecule["code"] == "Approved ANDA filers"
              ) {
                if (this.newdata.length > 0) {
                  for (let i = 0; i < this.newdata.length; i++) {
                    this.newexeclusivetycode = this.newdata[i]["ANDA No"];
                    newexeclusivetyarray.push(this.newexeclusivetycode);
                    this.newandadrugs = this.newdata[i]["Drug Name"];
                    newexeclusivetyarray.push(this.newexeclusivetycode);
                    this.newandaactive = this.newdata[i]["Active Ingredients"];
                    newexeclusivetyarray.push(this.newexeclusivetycode);
                    this.newstregth = this.newdata[i]["Strength"];
                    newexeclusivetyarray.push(this.newexeclusivetycode);
                    this.newRoa = this.newdata[i]["Dosage Form/Route"];
                    newexeclusivetyarray.push(this.newexeclusivetycode);
                    this.newmarketstatus = this.newdata[i]["Marketing Status"];
                    newexeclusivetyarray.push(this.newexeclusivetycode);
                    this.newapproval = this.newdata[i]["Approval Date"];
                    newexeclusivetyarray.push(this.newexeclusivetycode);
                    this.newapplicantholder =
                      this.newdata[i]["Applicant Holder"];
                    newexeclusivetyarray.push(this.newexeclusivetycode);
                  }
                }
                const transformedArray = this.newdata.map((item) => [
                  item["ANDA No"],
                  item["Drug Name"],
                  item["Active Ingredients"],
                  item["Strength"],
                  item["Dosage Form/Route"],
                  item["Marketing Status"],
                  item["Approval Date"],
                  item["Applicant Holder"],
                ]);
                this.olddata =
                  MoleculeData["data"][0]["updated_fileds"]["old_data"][detail][
                  "value"
                  ];
                // this.olddata = [this.olddata];
                if (typeof this.olddata !== "string") {
                  const oldtransformedArray = this.olddata.map((item) => {
                    const oldanda = item["ANDA No"] ?? "";
                    const oldaandadrug = item["Drug Name"] ?? "";
                    const oldandaactive = item["Active Ingredients"] ?? "";
                    const oldandastrength = item["Strength"] ?? "";
                    const oldandaroa = item["Dosage Form/Route"] ?? "";
                    const oldandamarket = item["Marketing Status"] ?? "";
                    const oldandaapproval = item["Approval Date"] ?? "";
                    const oldandaapplicant = item["Applicant Holder"] ?? "";
                    return [
                      oldanda,
                      oldaandadrug,
                      oldandaactive,
                      oldandastrength,
                      oldandaroa,
                      oldandamarket,
                      oldandaapproval,
                      oldandaapplicant,
                    ];
                  });
                  console.log(oldtransformedArray);
                  this.oldexeclusivetyarray = oldtransformedArray;
                } else {
                  const oldtransformedArray = [["N/A", "N/A", "N/A"]];
                  this.oldexeclusivetyarray = oldtransformedArray;
                  this.oldbutton = false;
                }
                this.newexeclusivetyarray = transformedArray;
                console.log(newexeclusivetyarray);
              }
              if (
                this.newdata != undefined &&
                this.selectedNDAMolecule["code"] == "Existing DMF filers"
              ) {
                if (this.newdata.length > 0) {
                  for (let i = 0; i < this.newdata.length; i++) {
                    this.newexeclusivetycode = this.newdata[i]["DMF#"];
                    newexeclusivetyarray.push(this.newexeclusivetycode);
                    this.newDmfHolder = this.newdata[i]["HOLDER"];
                    newexeclusivetyarray.push(this.newexeclusivetycode);
                    this.newDmfSubject = this.newdata[i]["SUBJECT"];
                    newexeclusivetyarray.push(this.newexeclusivetycode);
                    this.newDmfSubmitDate = this.newdata[i]["SUBMIT DATE"];
                    newexeclusivetyarray.push(this.newexeclusivetycode);
                  }
                }
                const transformedArray = this.newdata.map((item) => [
                  item["DMF#"],
                  item["HOLDER"],
                  item["SUBJECT"],
                  item["SUBMIT DATE"]
                ]);
                this.olddata =
                  MoleculeData["data"][0]["updated_fileds"]["old_data"][detail][
                  "value"
                  ];
                // this.olddata = [this.olddata];
                if (typeof this.olddata !== "string") {
                  const oldtransformedArray = this.olddata.map((item) => {
                    const oldDmf = item["DMF#"] ?? "";
                    const oldHolder = item["HOLDER"] ?? "";
                    const oldSubject = item["SUBJECT"] ?? "";
                    const oldSubmitDate = item["SUBMIT DATE"] ?? "";
                    return [
                      oldDmf,
                      oldHolder,
                      oldSubject,
                      oldSubmitDate,
                    ];
                  });
                  console.log(oldtransformedArray);
                  this.oldexeclusivetyarray = oldtransformedArray;
                } else {
                  const oldtransformedArray = [["N/A", "N/A", "N/A"]];
                  this.oldexeclusivetyarray = oldtransformedArray;
                  this.oldbutton = false;
                }
                this.newexeclusivetyarray = transformedArray;
                console.log(newexeclusivetyarray);
              }
              if (
                this.newdata != undefined &&
                this.selectedNDAMolecule["code"] == "IPR details (if any)"
              ) {
                if (this.newdata.length > 0) {
                  for (let i = 0; i < this.newdata.length; i++) {
                    this.newexeclusivetycode = this.newdata[i]["proceedingFilingDate"];
                    newexeclusivetyarray.push(this.newexeclusivetycode);
                    this.iprNumber = this.newdata[i]["proceedingNumber"];
                    newexeclusivetyarray.push(this.newexeclusivetycode);
                    this.iprResNumber = this.newdata[i]["respondentPatentNumber"];
                    newexeclusivetyarray.push(this.newexeclusivetycode);
                    this.iprPartyName = this.newdata[i]["petitionerPartyName"];
                    newexeclusivetyarray.push(this.newexeclusivetycode);
                    this.iprStatusCat = this.newdata[i]["proceedingStatusCategory"];
                    newexeclusivetyarray.push(this.newexeclusivetycode);
                    this.iprCounselName = this.newdata[i]["petitionerCounselName"];
                    newexeclusivetyarray.push(this.newexeclusivetycode);
                  }
                }
                const transformedArray = this.newdata.map((item) => [
                  item["proceedingFilingDate"],
                  item["proceedingNumber"],
                  item["respondentPatentNumber"],
                  item["petitionerPartyName"],
                  item["proceedingStatusCategory"],
                  item["petitionerCounselName"]
                ]);
                this.olddata =
                  MoleculeData["data"][0]["updated_fileds"]["old_data"][detail][
                  "value"
                  ];
                // this.olddata = [this.olddata];
                if (typeof this.olddata !== "string") {
                  const oldtransformedArray = this.olddata.map((item) => {
                    const oldiprFilingDate = item["Proceeding Filing Date"] ?? "";
                    const oldiprNum = item["Proceeding Number"] ?? "";
                    const oldiprPatent = item["Respondent Patent Number"] ?? "";
                    const oldiprPartyName = item["respondentPartyName"] ?? "";
                    const oldiprParName = item["Petitioner Party Name"] ?? "";
                    const oldiprStatusCat = item["Proceeding Status Category"] ?? "";
                    const oldiprTypeCat = item["Proceeding Type Category"] ?? "";
                    const oldiprDecisionDate = item["Decision Date"] ?? "";
                    return [
                      oldiprFilingDate,
                      oldiprNum,
                      oldiprPatent,
                      oldiprPartyName,
                      oldiprParName,
                      oldiprStatusCat,
                      oldiprTypeCat,
                      oldiprDecisionDate
                    ];
                  });
                  console.log(oldtransformedArray);
                  this.oldexeclusivetyarray = oldtransformedArray;
                } else {
                  const oldtransformedArray = [["N/A", "N/A", "N/A"]];
                  this.oldexeclusivetyarray = oldtransformedArray;
                  this.oldbutton = false;
                }
                this.newexeclusivetyarray = transformedArray;
                console.log(newexeclusivetyarray);
              }
              if (
                this.newdata != undefined &&
                this.selectedNDAMolecule["code"] == "Marketing Status"
              ) {
                if (this.newdata.length > 0) {
                  for (let i = 0; i < this.newdata.length; i++) {
                    this.newexeclusivetycode = this.newdata[i]["Strength"];
                    newexeclusivetyarray.push(this.newexeclusivetycode);
                    // this.newMarketingStatus = this.newdata[i]["Marketing Status"];
                    this.newMarketingStatus = this.newdata[i]["Marketing Status"] || this.newdata[i]["Mkt Status"];
                    newexeclusivetyarray.push(this.newexeclusivetycode);
                  }
                }
                const transformedArray = this.newdata.map((item) => [
                  item["Strength"],
                  item["Marketing Status"] || item["Mkt Status"],
                  // item["Marketing Status"],
                ]);
                this.olddata =
                  MoleculeData["data"][0]["updated_fileds"]["old_data"][detail][
                  "value"
                  ];
                // this.olddata = [this.olddata];
                if (typeof this.olddata !== "string") {
                  const oldtransformedArray = this.olddata.map((item) => {
                    const oldMarketStrength = item["Strength"] ?? "";
                    const oldMarketStatus = item["Mkt Status"] ?? "";
                    return [
                      oldMarketStrength,
                      oldMarketStatus,
                    ];
                  });
                  console.log(oldtransformedArray);
                  this.oldexeclusivetyarray = oldtransformedArray;
                } else {
                  const oldtransformedArray = [["N/A", "N/A", "N/A"]];
                  this.oldexeclusivetyarray = oldtransformedArray;
                  this.oldbutton = false;
                }
                this.newexeclusivetyarray = transformedArray;
                console.log(newexeclusivetyarray);
              }
              if (
                this.newdata != undefined &&
                this.selectedNDAMolecule["code"] == "PTE applied (Max 5 years)"
              ) {
                if (this.newdata.length > 0) {
                  for (let i = 0; i < this.newdata.length; i++) {
                    this.newexeclusivetycode = this.newdata[i]["Patent No"];
                    newexeclusivetyarray.push(this.newexeclusivetycode);
                    this.newPdeProduct = this.newdata[i]["Tradename of Product (generic name, if applicable)"];
                    newexeclusivetyarray.push(this.newexeclusivetycode);
                    this.newPdeExpiration = this.newdata[i]["Original Expiration Date*"];
                    newexeclusivetyarray.push(this.newexeclusivetycode);
                    this.newPdeExtension = this.newdata[i]["Period of Extension Granted"];
                    newexeclusivetyarray.push(this.newexeclusivetycode);
                  }
                }
                const transformedArray = this.newdata.map((item) => [
                  item["Patent No"],
                  item["Tradename of Product (generic name, if applicable)"],
                  item["Original Expiration Date*"],
                  item["Period of Extension Granted"],
                ]);
                this.olddata =
                  MoleculeData["data"][0]["updated_fileds"]["old_data"][detail][
                  "value"
                  ];
                // this.olddata = [this.olddata];
                if (typeof this.olddata !== "string") {
                  const oldtransformedArray = this.olddata.map((item) => {
                    const oldPdePatentNo = item["Patent No"] ?? "";
                    const oldPdeExpiration = item["Expiration date"] ?? "";
                    const oldPdeProduct = item["Product (Applicant for PTE)"] ?? "";
                    const oldPdeExtension = item["Extension Requested"] ?? "";
                    return [
                      oldPdePatentNo,
                      oldPdeExpiration,
                      oldPdeProduct,
                      oldPdeExtension
                    ];
                  });
                  console.log(oldtransformedArray);
                  this.oldexeclusivetyarray = oldtransformedArray;
                } else {
                  const oldtransformedArray = [["N/A", "N/A", "N/A"]];
                  this.oldexeclusivetyarray = oldtransformedArray;
                  this.oldbutton = false;
                }
                this.newexeclusivetyarray = transformedArray;
                console.log(newexeclusivetyarray);
              }
            }
            if (MoleculeData["message"] == "Success") {
              this.Molecule = true;
              this.toastr.success("Data Fetched Successfully");
              return;
            } else {
              this.toastr.error("Data Not Found !");
              return;
            }
          });
      }
    }
  }

  deleteTextBox(j, row) {
    this.valindex = j;
    this.row = row;
    this.deletedIndexes = j;
    this;
    this.deletedRowNewValue.push(row);
    const indexOfRowToDelete = j;
    if (indexOfRowToDelete !== -1) {
      this.newdata.splice(indexOfRowToDelete, 1);
    }
    if (this.newexeclusivetyarray != undefined) {
      this.newexeclusivetyarray.splice(j, 1);
    } else {
      this.indicativeSpecificNewData = undefined;
    }
  }

  updateNewData(rowindex: number, newValue: string, columnName: string) {
    if (!this.rowData[rowindex]) {
      this.rowData[rowindex] = newValue;
    } else {
      this.rowData[rowindex] = newValue;
    }

    if (!this.editedData[rowindex]) {
      this.editedData[rowindex] = {};
    }

    // Update the edited value for the corresponding row with an appropriate key
    this.editedData[rowindex][columnName] = newValue;
    this.rowData[rowindex] = newValue;
    if (!this.editedData[rowindex]) {
      this.editedData[rowindex] = {};
    }

    // Update the edited value for the corresponding row and input field
    this.editedData[rowindex][rowindex] = newValue;
  }

  areArraysEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) {
      return false;
    }
    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i] !== arr2[i]) {
        return false;
      }
    }
    return true;
  }

  areAllStringValues(obj) {
    for (const key in obj) {
      if (typeof obj[key] !== "string") {
        return false;
      }
    }
    return true;
  }

  Approved(newexeclusivetyarray, isValueChangedNew?: any, olddata?: any) {
    const allValuesAreStrings = this.areAllStringValues(this.newdata);
    console.log(allValuesAreStrings);
    console.log("Deleted value:", this.row);
    var isValueChanged = isValueChangedNew;
    var newValuenew1: any;
    var volumeheaderNew: any[];
    let Exclusivity: any = {};
    let deletedRowValue: any = [];
    let selectedNDAMolecule = this.selectedNDAMolecule["code"];
    if (this.newdata != undefined) {
      for (let i = 0; i < this.newdata.length; i++) {
        const newObj = {};
        for (const key in this.newdata[i]) {
          if (typeof this.newdata[i][key] !== "string") {
            newObj[key] = String(this.newdata[i][key]); // Convert non-string values to strings
          } else {
            newObj[key] = this.newdata[i][key];
          }
        }
        this.newdata[i] = newObj;
      }
    }
    console.log(this.newdata);
    if (selectedNDAMolecule == "Exclusivity details") {
      volumeheaderNew = [
        "Exclusivity Code",
        "Exclusivity Expiration",
        "Strength",
      ];
      Exclusivity = this.newexeclusivetyarray.map((item) => {
        return {
          "Exclusivity Code": item[0], // Get value from datalist at index 0
          "Exclusivity Expiration": item[1], // Get value from datalist at index 1
          Strength: item[2], // Get value from datalist at index 2
        };
      });
      if (this.deletedRowNewValue && this.deletedRowNewValue.length > 0) {
        this.deletedRowNewValue.forEach((element) => {
          var deletedRowNewValue = {
            "Exclusivity Code": element[0],
            "Exclusivity Expiration": element[1],
            Strength: element[2],
          };
          deletedRowValue.push(deletedRowNewValue);
        });
        console.log(deletedRowValue);
      }
    }
    if (selectedNDAMolecule == "Innovator / RLD Price ($/pack)") {
      volumeheaderNew = ["Quantity", "Per unit", "Price", "Strengths", "Roa"];
      Exclusivity = this.newexeclusivetyarray.map((item) => {
        return {
          Quantity: item[0],
          "Per unit": item[1],
          Price: item[2],
          Strengths: item[3],
          Roa: item[4],
        };
      });
      if (this.deletedRowNewValue && this.deletedRowNewValue.length > 0) {
        this.deletedRowNewValue.forEach((element) => {
          var deletedRowNewValue = {
            Quantity: element[0],
            "Per unit": element[1],
            Price: element[2],
            Strengths: element[3],
            Roa: element[4],
          };
          deletedRowValue.push(deletedRowNewValue);
        });
      }
    }
    if (selectedNDAMolecule == "Indicative API price ($/kg)") {
      Exclusivity = this.indicativeSpecificNewData;
    }
    if (selectedNDAMolecule == "PDE applied 6 months*") {
      Exclusivity = this.indicativeSpecificNewData;
    }
    if (selectedNDAMolecule == "Orphan Drug Exclusivity") {
      Exclusivity = this.indicativeSpecificNewData;
    }
    if (selectedNDAMolecule == "Reference Listed Drug (RLD)") {
      Exclusivity = this.indicativeSpecificNewData;
    }
    if (selectedNDAMolecule == "Reference Standard (RS)") {
      Exclusivity = this.indicativeSpecificNewData;
    }
    if (selectedNDAMolecule == "Approved ANDA filers") {
      volumeheaderNew = [
        "ANDA No",
        "Drug Name",
        "Active Ingredients",
        "Strength",
        "Dosage Form/Route",
        "Marketing Status",
        "Approval Date",
        "Applicant Holder",
      ];
      Exclusivity = this.newexeclusivetyarray.map((item) => {
        return {
          "ANDA No": item[0],
          "Drug Name": item[1],
          "Active Ingredients": item[2],
          Strength: item[3],
          "Dosage Form/Route": item[4],
          "Marketing Status": item[5],
          "Approval Date": item[6],
          "Applicant Holder": item[7],
        };
      });
      if (this.deletedRowNewValue && this.deletedRowNewValue.length > 0) {
        this.deletedRowNewValue.forEach((element) => {
          var deletedRowNewValue = {
            "ANDA No": element[0],
            "Drug Name": element[1],
            "Active Ingredients": element[2],
            Strength: element[3],
            "Dosage Form/Route": element[4],
            "Marketing Status": element[5],
            "Approval Date": element[6],
            "Applicant Holder": element[7],
          };
          deletedRowValue.push(deletedRowNewValue);
        });
      }
    }
    if (selectedNDAMolecule == "Existing DMF filers") {
      volumeheaderNew = [
        "DMF#",
        "SUBMIT DATE",
        "HOLDER",
        "SUBJECT",
      ];
      Exclusivity = this.newexeclusivetyarray.map((item) => {
        return {
          "DMF#": item[0],
          "SUBMIT DATE": item[1],
          "HOLDER": item[2],
          "SUBJECT": item[3],
        };
      });
      if (this.deletedRowNewValue && this.deletedRowNewValue.length > 0) {
        this.deletedRowNewValue.forEach((element) => {
          var deletedRowNewValue = {
            "DMF#": element[0],
            "SUBMIT DATE": element[1],
            "HOLDER": element[2],
            "SUBJECT": element[3],
          };
          deletedRowValue.push(deletedRowNewValue);
        });
      }
    }
    if (selectedNDAMolecule == "IPR details (if any)") {
      volumeheaderNew = [
        "proceedingFilingDate",
        "proceedingNumber",
        "respondentPatentNumber",
        "petitionerPartyName",
        "proceedingStatusCategory",
        "petitionerCounselName",
      ];
      Exclusivity = this.newexeclusivetyarray.map((item) => {
        return {
          "proceedingFilingDate": item[0],
          "proceedingNumber": item[1],
          "respondentPatentNumber": item[2],
          "petitionerPartyName": item[3],
          "proceedingStatusCategory": item[4],
          "petitionerCounselName": item[5],
        };
      });
      if (this.deletedRowNewValue && this.deletedRowNewValue.length > 0) {
        this.deletedRowNewValue.forEach((element) => {
          var deletedRowNewValue = {
            "proceedingFilingDate": element[0],
            "proceedingNumber": element[1],
            "respondentPatentNumber": element[2],
            "petitionerPartyName": element[3],
            "proceedingStatusCategory": element[4],
            "petitionerCounselName": element[5]
          };
          deletedRowValue.push(deletedRowNewValue);
        });
      }
    }
    if (selectedNDAMolecule == "Marketing Status") {
      volumeheaderNew = [
        "Strength",
        "Marketing Status",
      ];
      Exclusivity = this.newexeclusivetyarray.map((item) => {
        return {
          "Strength": item[0],
          "Marketing Status": item[1],
        };
      });
      if (this.deletedRowNewValue && this.deletedRowNewValue.length > 0) {
        this.deletedRowNewValue.forEach((element) => {
          var deletedRowNewValue = {
            "Strength": element[0],
            "Marketing Status": element[1],
          };
          deletedRowValue.push(deletedRowNewValue);
        });
      }
    }
    if (selectedNDAMolecule == "PTE applied (Max 5 years)") {
      volumeheaderNew = [
        "Patent No",
        "Tradename of Product (generic name, if applicable)",
        "Original Expiration Date*",
        "Period of Extension Granted",
      ];
      Exclusivity = this.newexeclusivetyarray.map((item) => {
        return {
          "Patent No": item[0],
          "Tradename of Product (generic name, if applicable)": item[1],
          "Original Expiration Date*": item[2],
          "Period of Extension Granted": item[3],
        };
      });
      if (this.deletedRowNewValue && this.deletedRowNewValue.length > 0) {
        this.deletedRowNewValue.forEach((element) => {
          var deletedRowNewValue = {
            "Patent No": element[0],
            "Tradename of Product (generic name, if applicable)": element[1],
            "Original Expiration Date*": element[2],
            "Period of Extension Granted": element[3],
          };
          deletedRowValue.push(deletedRowNewValue);
        });
      }
    }
    if (isValueChangedNew === "new_data") {
      volumeheaderNew?.forEach((element, index) => {
        var newIDNew: any = (<HTMLInputElement>(
          document.getElementById("volume" + this.valindex + "row" + index)
        ))?.value;
        if (newIDNew) {
          newValuenew1 = {
            [element]: newIDNew,
            newValuenew1,
          };
        }
      });
      if (newValuenew1) {
        const values = Object.values(newValuenew1);
        if (this.areArraysEqual(this.row, values?.reverse())) {
          isValueChanged = "only_approved";
        }
      }
    }
    let ndaValue = {};
    if (
      isValueChanged === "only_approved" &&
      deletedRowValue.length > 0 &&
      this.indicativeSpecificNewData == undefined &&
      this.newexeclusivetyarray != undefined
    ) {
      ndaValue = {
        status: this.selectedSubMolecule["code"].trim(),
        nda_number: this.selectedFieldMolecule["code"].split(",")[1].trim(),
        brand_name: this.selectedFieldMolecule["code"].split(",")[0].trim(),
        field_name: this.extractedValue,
        updated_fileds: this.specifiecdata,
        email: this.email,
        ip: this.UserIp,
        edited_data: {
          [selectedNDAMolecule]: {
            value: [],
          },
        },
        approved_data: {
          [selectedNDAMolecule]: {
            value: Exclusivity,
          },
        },
        removed_data: {
          [selectedNDAMolecule]: {
            value: deletedRowValue,
          },
        },
        removed: true,
        edited: false,
        ids: this.id,
      };
    } else if (
      isValueChanged === "only_approved" &&
      deletedRowValue.length == 0 &&
      this.indicativeSpecificNewData == undefined &&
      this.newexeclusivetyarray != undefined
    ) {
      ndaValue = {
        status: this.selectedSubMolecule["code"].trim(),
        nda_number: this.selectedFieldMolecule["code"].split(",")[1].trim(),
        brand_name: this.selectedFieldMolecule["code"].split(",")[0].trim(),
        field_name: this.extractedValue,
        updated_fileds: this.specifiecdata,
        email: this.email,
        ip: this.UserIp,
        edited_data: {
          [selectedNDAMolecule]: {
            value: [],
          },
        },
        approved_data: {
          [selectedNDAMolecule]: {
            value: Exclusivity,
          },
        },
        removed: false,
        edited: false,
        ids: this.id,
      };
    } else if (
      isValueChanged === "new_data" &&
      deletedRowValue.length == 0 &&
      this.indicativeSpecificNewData == undefined &&
      this.newexeclusivetyarray != undefined
    ) {
      const newValue1: any = {};
      newexeclusivetyarray.forEach((row, rowIndex) => {
        row.forEach((element, index) => {
          // Check if the input element is being edited
          const newID: any = (<HTMLInputElement>(
            document.getElementById(`volume${rowIndex}row${index}`)
          ))?.value;
          // Update newValue1 with the edited value
          if (newID) {
            if (!newValue1[rowIndex]) {
              newValue1[rowIndex] = {};
            }
            newValue1[rowIndex][volumeheaderNew[index]] = newID;
          }
        });
      });
      let updatedItem: any = {};
      if (selectedNDAMolecule === "Exclusivity details") {
        Object.keys(newValue1).forEach((rowIndex) => {
          updatedItem = {
            "Exclusivity Code": newValue1[rowIndex]["Exclusivity Code"],
            "Exclusivity Expiration":
              newValue1[rowIndex]["Exclusivity Expiration"],
            Strength: newValue1[rowIndex]["Strength"],
          };
          // Replace or insert the specific row in the newdata array
          this.newdata[rowIndex] = updatedItem;
        });
      }
      if (selectedNDAMolecule == "Innovator / RLD Price ($/pack)") {
        Object.keys(newValue1).forEach((rowIndex) => {
          // Prepare an array with the updated information
          updatedItem = {
            Quantity: newValue1[rowIndex]["Quantity"],
            "Per unit": newValue1[rowIndex]["Per unit"],
            Price: newValue1[rowIndex]["Price"],
            Strengths: newValue1[rowIndex]["Strengths"],
            Roa: newValue1[rowIndex]["Roa"],
          };
          this.newdata[rowIndex] = updatedItem;
        });
      }
      if (selectedNDAMolecule == "Approved ANDA filers") {
        Object.keys(newValue1).forEach((rowIndex) => {
          // Prepare an array with the updated information
          updatedItem = {
            "ANDA No": newValue1[rowIndex]["ANDA No"], // Get value from datalist at index 0
            "Drug Name": newValue1[rowIndex]["Drug Name"], // Get value from datalist at index 1
            "Active Ingredients": newValue1[rowIndex]["Active Ingredients"], // Get value from datalist at index 2
            Strength: newValue1[rowIndex]["Strength"],
            "Dosage Form/Route": newValue1[rowIndex]["Dosage Form/Route"],
            "Marketing Status": newValue1[rowIndex]["Marketing Status"],
            "Approval Date": newValue1[rowIndex]["Approval Date"],
            "Applicant Holder": newValue1[rowIndex]["Applicant Holder"],
          };
          this.newdata[rowIndex] = updatedItem;
        });
      }
      if (selectedNDAMolecule == "Existing DMF filers") {
        Object.keys(newValue1).forEach((rowIndex) => {
          // Prepare an array with the updated information
          updatedItem = {
            "DMF#": newValue1[rowIndex]["DMF#"], // Get value from datalist at index 0
            "SUBMIT DATE": newValue1[rowIndex]["SUBMIT DATE"], // Get value from datalist at index 1
            "HOLDER": newValue1[rowIndex]["HOLDER"], // Get value from datalist at index 2
            "SUBJECT": newValue1[rowIndex]["SUBJECT"],
          };
          this.newdata[rowIndex] = updatedItem;
        });
      }
      if (selectedNDAMolecule == "IPR details (if any)") {
        Object.keys(newValue1).forEach((rowIndex) => {
          // Prepare an array with the updated information
          updatedItem = {
            "proceedingFilingDate": newValue1[rowIndex]["proceedingFilingDate"], // Get value from datalist at index 0
            "proceedingNumber": newValue1[rowIndex]["proceedingNumber"], // Get value from datalist at index 1
            "respondentPatentNumber": newValue1[rowIndex]["respondentPatentNumber"], // Get value from datalist at index 2
            "petitionerPartyName": newValue1[rowIndex]["petitionerPartyName"],
            "proceedingStatusCategory": newValue1[rowIndex]["proceedingStatusCategory"],
            "petitionerCounselName": newValue1[rowIndex]["petitionerCounselName"],
          };
          this.newdata[rowIndex] = updatedItem;
        });
      }
      // if (selectedNDAMolecule == "Marketing Status") {
      //   Object.keys(newValue1).forEach((rowIndex) => {
      //     // Prepare an array with the updated information
      //     updatedItem = {
      //       "Strength": newValue1[rowIndex]["Strength"], // Get value from datalist at index 0
      //       "Marketing Status": newValue1[rowIndex]["Marketing Status"], // Get value from datalist at index 1
      //     };
      //     this.newdata[rowIndex] = updatedItem;
      //   });
      // }
      if (selectedNDAMolecule == "Marketing Status") {
        Object.keys(newValue1).forEach((rowIndex) => {
          // Determine the correct key for Marketing Status
          const marketingStatusKey = "Marketing Status" in newValue1[rowIndex] ? "Marketing Status" : "Mkt Status";

          // Prepare an array with the updated information
          const updatedItem = {
            "Strength": newValue1[rowIndex]["Strength"], // Get value from datalist at index 0
            [marketingStatusKey]: newValue1[rowIndex][marketingStatusKey], // Get value from datalist at index 1
          };

          this.newdata[rowIndex] = updatedItem;
        });
      }

      if (selectedNDAMolecule == "PTE applied (Max 5 years)") {
        Object.keys(newValue1).forEach((rowIndex) => {
          // Prepare an array with the updated information
          updatedItem = {
            "Patent No": newValue1[rowIndex]["Patent No"], // Get value from datalist at index 0
            "Tradename of Product (generic name, if applicable)": newValue1[rowIndex]["Tradename of Product (generic name, if applicable)"], // Get value from datalist at index 1
            "Original Expiration Date*": newValue1[rowIndex]["Original Expiration Date*"], // Get value from datalist at index 0
            "Period of Extension Granted": newValue1[rowIndex]["Period of Extension Granted"], // Get value from datalist at index 1
          };
          this.newdata[rowIndex] = updatedItem;
        });
      }
      // Replace or insert the first item in the newexeclusivetyarray
      // this.newdata = [updatedItem, ...this.newdata.slice(1)];
      this.showedit = !this.showedit;
      ndaValue = {
        status: this.selectedSubMolecule["code"].trim(),
        nda_number: this.selectedFieldMolecule["code"].split(",")[1].trim(),
        brand_name: this.selectedFieldMolecule["code"].split(",")[0].trim(),
        field_name: this.extractedValue,
        updated_fileds: this.specifiecdata,
        email: this.email,
        ip: this.UserIp,
        edited_data: {
          [selectedNDAMolecule]: {
            value: this.newdata,
          },
        },
        approved_data: {
          [selectedNDAMolecule]: {
            value: Exclusivity,
          },
        },
        removed: false,
        edited: true,
        ids: this.id,
      };
    } else if (
      isValueChanged === "new_data" &&
      deletedRowValue.length > 0 &&
      this.indicativeSpecificNewData == undefined &&
      this.newexeclusivetyarray != undefined
    ) {
      const newValue1: any = {};
      let updatedItem: any = {};
      newexeclusivetyarray.forEach((row, rowIndex) => {
        row.forEach((element, index) => {
          const newID: any = (<HTMLInputElement>(
            document.getElementById(`volume${rowIndex}row${index}`)
          ))?.value;
          // Update newValue1 with the edited value
          if (newID) {
            if (!newValue1[rowIndex]) {
              newValue1[rowIndex] = {};
            }
            newValue1[rowIndex][volumeheaderNew[index]] = newID;
          }
        });
      });
      console.log(newValue1);
      // Update this.newdata with edited values from newValue1
      if (selectedNDAMolecule === "Exclusivity details") {
        Object.keys(newValue1).forEach((rowIndex) => {
          updatedItem = {
            "Exclusivity Code": newValue1[rowIndex]["Exclusivity Code"],
            "Exclusivity Expiration":
              newValue1[rowIndex]["Exclusivity Expiration"],
            Strength: newValue1[rowIndex]["Strength"],
          };
          this.newdata[rowIndex] = { ...updatedItem };
        });
        // this.newdata = this.newdata.filter((dataItem: any) => {
        //   let isDeleted = false;
        //   // Check if the current row matches any of the deleted rows
        //   deletedRowValue.forEach((deletedRow: any) => {
        //     if (
        //       deletedRow["Exclusivity Code"] === dataItem["Exclusivity Code"] &&
        //       deletedRow["Exclusivity Expiration"] ===
        //         dataItem["Exclusivity Expiration"] &&
        //       deletedRow["Strength"] === dataItem["Strength"]
        //     ) {
        //       isDeleted = true;
        //     }
        //   });
        //   return !isDeleted;
        // });
      }
      if (selectedNDAMolecule === "Approved ANDA filers") {
        Object.keys(newValue1).forEach((rowIndex) => {
          updatedItem = {
            "ANDA No": newValue1[rowIndex]["ANDA No"], // Get value from datalist at index 0
            "Drug Name": newValue1[rowIndex]["Drug Name"], // Get value from datalist at index 1
            "Active Ingredients": newValue1[rowIndex]["Active Ingredients"], // Get value from datalist at index 2
            Strength: newValue1[rowIndex]["Strength"],
            "Dosage Form/Route": newValue1[rowIndex]["Dosage Form/Route"],
            "Marketing Status": newValue1[rowIndex]["Marketing Status"],
            "Approval Date": newValue1[rowIndex]["Approval Date"],
            "Applicant Holder": newValue1[rowIndex]["Applicant Holder"],
          };
          this.newdata[rowIndex] = { ...updatedItem };
        });
      }
      if (selectedNDAMolecule === "Existing DMF filers") {
        Object.keys(newValue1).forEach((rowIndex) => {
          updatedItem = {
            "DMF#": newValue1[rowIndex]["DMF#"], // Get value from datalist at index 0
            "SUBMIT DATE": newValue1[rowIndex]["SUBMIT DATE"], // Get value from datalist at index 1
            "HOLDER": newValue1[rowIndex]["HOLDER"], // Get value from datalist at index 2
            "SUBJECT": newValue1[rowIndex]["SUBJECT"],
          };
          this.newdata[rowIndex] = { ...updatedItem };
        });
      }
      if (selectedNDAMolecule == "Marketing Status") {
        Object.keys(newValue1).forEach((rowIndex) => {
          // Determine the correct key for Marketing Status
          const marketingStatusKey = "Marketing Status" in newValue1[rowIndex] ? "Marketing Status" : "Mkt Status";

          // Prepare an array with the updated information
          const updatedItem = {
            "Strength": newValue1[rowIndex]["Strength"], // Get value from datalist at index 0
            [marketingStatusKey]: newValue1[rowIndex][marketingStatusKey], // Get value from datalist at index 1
          };

          this.newdata[rowIndex] = updatedItem;
        });
      }
      if (selectedNDAMolecule === "IPR details (if any)") {
        Object.keys(newValue1).forEach((rowIndex) => {
          updatedItem = {
            "proceedingFilingDate": newValue1[rowIndex]["proceedingFilingDate"], // Get value from datalist at index 0
            "proceedingNumber": newValue1[rowIndex]["proceedingNumber"], // Get value from datalist at index 1
            "respondentPatentNumber": newValue1[rowIndex]["respondentPatentNumber"], // Get value from datalist at index 2
            "petitionerPartyName": newValue1[rowIndex]["petitionerPartyName"],
            "proceedingStatusCategory": newValue1[rowIndex]["proceedingStatusCategory"],
            "petitionerCounselName": newValue1[rowIndex]["petitionerCounselName"],
          };
          this.newdata[rowIndex] = { ...updatedItem };
        });
      }
      if (selectedNDAMolecule == "Innovator / RLD Price ($/pack)") {
        this.newdata.forEach((_, index) => {
          if (newValue1[index]) {
            // Prepare an array with the updated information
            updatedItem = {
              Quantity: newValue1[index]["Quantity"],
              "Per unit": newValue1[index]["Per unit"],
              Price: newValue1[index]["Price"],
              Strengths: newValue1[index]["Strengths"],
              Roa: newValue1[index]["Roa"],
            };
            this.newdata[index] = { ...updatedItem }; // Assign a new object
          }
        });
        this.newdata = this.newdata.filter((dataItem: any) => {
          let isDeleted = false;
          // Check if the current row matches any of the deleted rows
          deletedRowValue.forEach((deletedRow: any) => {
            if (
              deletedRow["Quantity"] === dataItem["Quantity"] &&
              deletedRow["Per unit"] === dataItem["Per unit"] &&
              deletedRow["Price"] === dataItem["Price"] &&
              deletedRow["Strengths"] === dataItem["Strengths"] &&
              deletedRow["Roa"] === dataItem["Roa"]
            ) {
              isDeleted = true;
            }
          });
          return !isDeleted;
        });
      }
      if (selectedNDAMolecule === "PTE applied (Max 5 years)") {
        Object.keys(newValue1).forEach((rowIndex) => {
          updatedItem = {
            "Patent No": newValue1[rowIndex]["Patent No"], // Get value from datalist at index 0
            "Tradename of Product (generic name, if applicable)": newValue1[rowIndex]["Tradename of Product (generic name, if applicable)"], // Get value from datalist at index 1
            "Original Expiration Date*": newValue1[rowIndex]["Original Expiration Date*"], // Get value from datalist at index 0
            "Period of Extension Granted": newValue1[rowIndex]["Period of Extension Granted"], // Get value from datalist at index 1
          };
          this.newdata[rowIndex] = { ...updatedItem };
        });
      }
      this.showedit = !this.showedit;
      ndaValue = {
        status: this.selectedSubMolecule["code"].trim(),
        nda_number: this.selectedFieldMolecule["code"].split(",")[1].trim(),
        brand_name: this.selectedFieldMolecule["code"].split(",")[0].trim(),
        field_name: this.extractedValue,
        updated_fileds: this.specifiecdata,
        email: this.email,
        ip: this.UserIp,
        edited_data: {
          [selectedNDAMolecule]: {
            value: this.newdata,
          },
        },
        approved_data: {
          [selectedNDAMolecule]: {
            value: Exclusivity,
          },
        },
        removed_data: {
          [selectedNDAMolecule]: {
            value: deletedRowValue,
          },
        },
        removed: true,
        edited: true,
        ids: this.id,
      };
    } else if (
      isValueChanged === "only_approved" &&
      deletedRowValue.length > 0 &&
      this.indicativeSpecificNewData == undefined &&
      this.newexeclusivetyarray != undefined
    ) {
      ndaValue = {
        status: this.selectedSubMolecule["code"].trim(),
        nda_number: this.selectedFieldMolecule["code"].split(",")[1].trim(),
        brand_name: this.selectedFieldMolecule["code"].split(",")[0].trim(),
        field_name: this.extractedValue,
        updated_fileds: this.specifiecdata,
        email: this.email,
        ip: this.UserIp,
        edited_data: {
          [selectedNDAMolecule]: {
            value: [],
          },
        },
        approved_data: {
          [selectedNDAMolecule]: {
            value: Exclusivity,
          },
        },
        removed_data: {
          [selectedNDAMolecule]: {
            value: deletedRowValue,
          },
        },
        removed: true,
        edited: false,
        ids: this.id,
      };
    } else if (
      isValueChanged === "new_data" &&
      this.indicativeSpecificNewData != undefined &&
      this.newexeclusivetyarray == undefined &&
      (selectedNDAMolecule === "Indicative API price ($/kg)" ||
        selectedNDAMolecule === "PDE applied 6 months*" ||
        selectedNDAMolecule === "Orphan Drug Exclusivity" ||
        selectedNDAMolecule == "Reference Listed Drug (RLD)" ||
        selectedNDAMolecule == "Reference Standard (RS)")
    ) {
      const newValue1: any = {};
      var textBox = document.getElementById(
        "volume" + 0 + "row" + 0
      ) as HTMLInputElement;
      if (textBox) {
        var value = textBox.value;
        console.log("Textbox value:", value);
        this.row = value;
        this.showedit = !this.showedit;
        ndaValue = {
          status: this.selectedSubMolecule["code"].trim(),
          nda_number: this.selectedFieldMolecule["code"].split(",")[1].trim(),
          brand_name: this.selectedFieldMolecule["code"].split(",")[0].trim(),
          field_name: this.extractedValue,
          updated_fileds: this.specifiecdata,
          email: this.email,
          ip: this.UserIp,
          edited_data: {
            [selectedNDAMolecule]: {
              value: this.row,
            },
          },
          approved_data: {
            [selectedNDAMolecule]: {
              value: this.indicativeSpecificNewData,
            },
          },
          removed: false,
          edited: true,
          ids: this.id,
        };
      }
    } else if (
      isValueChanged === "only_approved" &&
      this.indicativeSpecificNewData != undefined &&
      this.newexeclusivetyarray == undefined &&
      (selectedNDAMolecule === "Indicative API price ($/kg)" ||
        selectedNDAMolecule === "PDE applied 6 months*" ||
        selectedNDAMolecule === "Orphan Drug Exclusivity" ||
        selectedNDAMolecule == "Reference Listed Drug (RLD)" ||
        selectedNDAMolecule == "Reference Standard (RS)")
    ) {
      const newValue1: any = {};
      this.showedit = !this.showedit;
      ndaValue = {
        status: this.selectedSubMolecule["code"].trim(),
        nda_number: this.selectedFieldMolecule["code"].split(",")[1].trim(),
        brand_name: this.selectedFieldMolecule["code"].split(",")[0].trim(),
        field_name: this.extractedValue,
        updated_fileds: this.specifiecdata,
        email: this.email,
        ip: this.UserIp,
        edited_data: {
          [selectedNDAMolecule]: {
            value: this.row,
          },
        },
        approved_data: {
          [selectedNDAMolecule]: {
            value: this.indicativeSpecificNewData,
          },
        },
        // edited_data: {
        //   "Indicative API price ($/kg)": {
        //     value: "",
        //   },
        // },
        // approved_data: {
        //   "Indicative API price ($/kg)": {
        //     value: this.indicativeSpecificNewData,
        //   },
        // },
        // removed_data: {
        //   "Indicative API price ($/kg)": {
        //     value: this.deletedRowValue,
        //   },
        // },
        removed: false,
        edited: false,
        ids: this.id,
      };
    }
    this.scrapingupdateservice
      .getApprovedFieldData(ndaValue)
      .subscribe((res: any) => {
        if (res.data !== "N/A" && res.product_data !== "N/A") {
          // if (res.data === "N/A" && res.product_data === "N/A") {
          //   location.reload();
          // }
          this.id = res["data"][0]["_id"];
          this.nda_number = res["data"][0]["NDA number"];
          this.brand_name = res["data"][0]["Brand Name"];
          this.roa = res["data"][0]["roa"];
          this.dosage_form = res["data"][0]["Dosage forms"];
          this.natural_dosage_form = res["data"][0]["Nature of Dosage form"];
          this.newdata =
            res["data"][0]["pending data"]["Exclusivity details"]["value"];
          this.olddata = res["data"][0]["updated_fileds"]["old_data"];
          let newexeclusivetyarray = [];
          let newexclusivityexpirationarray = [];
          let newstregtharray = [];
          if (this.newdata.length > 0) {
            for (let i = 0; i < this.newdata.length; i++) {
              this.newexeclusivetycode = this.newdata[i]["Exclusivity Code"];
              newexeclusivetyarray.push(this.newexeclusivetycode);
              this.newexclusivityexpiration =
                this.newdata[i]["Exclusivity Expiration"];
              newexeclusivetyarray.push(this.newexeclusivetycode);
              this.newstregth = this.newdata[i]["Exclusivity Expiration"];
              newexeclusivetyarray.push(this.newexeclusivetycode);
            }
          }
          const transformedArray = this.newdata.map((item) => [
            item["Exclusivity Code"],
            item["Exclusivity Expiration"],
            item["Strength"],
          ]);
          this.newexeclusivetyarray = transformedArray;
          if (this.olddata.length > 0 && this.olddata.type != String) {
            const oldtransformedArray = this.olddata.map((item) => [
              item["Exclusivity Code"],
              item["Exclusivity Expiration"],
              item["Strength"],
            ]);
            this.oldexeclusivetyarray = oldtransformedArray;
          } else {
            this.oldexeclusivetycode = "N/A";
            this.oldexclusivityexpiration = "N/A";
          }
        }
        if (res["message"] == "Success") {
          if (res.data === "N/A" && res.product_data === "N/A") {
            location.reload();
          }
          this.toastr.success("Data Approved successfully");
          return;
        } else {
          this.toastr.error("Data not saved !");
          return;
        }
      });
  }

  Reject(datalist) {
    let Exclusivity: any = {};
    let selectedNDAMolecule = this.selectedNDAMolecule["code"];
    if (this.selectedNDAMolecule["code"] == "Exclusivity details") {
      Exclusivity = this.newexeclusivetyarray.map((item) => {
        return {
          "Exclusivity Code": item[0],
          "Exclusivity Expiration": item[1],
          Strength: item[2],
        };
      });
    } else if (
      this.selectedNDAMolecule["code"] == "Innovator / RLD Price ($/pack)"
    ) {
      Exclusivity = this.newexeclusivetyarray.map((item) => {
        return {
          Quantity: item[0],
          "Per unit": item[1],
          Price: item[2],
          Strengths: item[3],
          Roa: item[4],
        };
      });
      console.log(Exclusivity);
    } else if (
      this.selectedNDAMolecule["code"] == "Indicative API price ($/kg)"
    ) {
      Exclusivity = this.indicativeSpecificOldData;
    }
    else if (
      this.selectedNDAMolecule["code"] == "PDE applied 6 months*"
    ) {
      Exclusivity = this.indicativeSpecificOldData;
    }
    else if (
      this.selectedNDAMolecule["code"] == "Orphan Drug Exclusivity"
    ) {
      Exclusivity = this.indicativeSpecificOldData;
    }
    else if (
      this.selectedNDAMolecule["code"] == "Reference Listed Drug (RLD)"
    ) {
      Exclusivity = this.indicativeSpecificOldData;
    }
    else if (
      this.selectedNDAMolecule["code"] == "Reference Standard (RS)"
    ) {
      Exclusivity = this.indicativeSpecificOldData;
    }
    else if (
      this.selectedNDAMolecule["code"] == "Existing DMF filers"
    ) {
      Exclusivity = this.newexeclusivetyarray.map((item) => {
        return {
          "DMF#": item[0],
          "SUBMIT DATE": item[1],
          "HOLDER": item[2],
          "SUBJECT": item[3],
        };
      });
      console.log(Exclusivity);
    }
    else if (
      this.selectedNDAMolecule["code"] == "IPR details (if any)"
    ) {
      Exclusivity = this.newexeclusivetyarray.map((item) => {
        return {
          "proceedingFilingDate": item[0],
          "proceedingNumber": item[1],
          "respondentPatentNumber": item[2],
          "petitionerPartyName": item[3],
          "proceedingStatusCategory": item[4],
          "petitionerCounselName": item[5],
        };
      });
      console.log(Exclusivity);
    }
    else if (
      this.selectedNDAMolecule["code"] == "Marketing Status"
    ) {
      Exclusivity = this.newexeclusivetyarray.map((item) => {
        return {
          "Strength": item[0],
          "Marketing Status": item[1],
        };
      });
      console.log(Exclusivity);
    }
    else if (
      this.selectedNDAMolecule["code"] == "PTE applied (Max 5 years)"
    ) {
      Exclusivity = this.newexeclusivetyarray.map((item) => {
        return {
          "Patent No": item[0],
          "Tradename of Product (generic name, if applicable)": item[1],
          "Original Expiration Date*": item[2],
          "Period of Extension Granted": item[3],
        };
      });
      console.log(Exclusivity);
    }
    let ndaValue = {
      status: this.selectedSubMolecule["code"].trim(),
      nda_number: this.selectedFieldMolecule["code"].split(",")[1].trim(),
      brand_name: this.selectedFieldMolecule["code"].split(",")[0].trim(),
      field_name: this.extractedValue,
      email: this.email,
      ip: this.UserIp,
      rejected_data: {
        [selectedNDAMolecule]: {
          value: Exclusivity,
        },
      },
      ids: this.id,
    };
    this.scrapingupdateservice
      .getRejectFieldData(ndaValue)
      .subscribe((res: any) => {
        if (res["message"] == "Success") {
          this.toastr.success("Data Rejected successfully");
          if (res.data === "N/A" && res.product_data === "N/A") {
            location.reload();
          }
          return;
        } else {
          this.toastr.error("Data not reject !");
          return;
        }
      });
  }

  editbtn(j, row) {
    this.valindex = j;
    this.row = row;
    this.showedit = !this.showedit;
    if (this.showedit === true) {
      this.sliceEnd = 1000;
    } else {
      this.sliceEnd = 5;
    }
  }
}
